import BackgroundUnderlay from "@components/BuyForm/BackgroundUnderlay";
import BuyStepJumper from "@components/BuyForm/BuyStepJumper";
import FooterLinks from "@components/BuyForm/FooterLinks";
import Header from "@components/BuyForm/Header/Header";
import { withHeaderLayout } from "@components/BuyForm/Header/withHeaderLayout";
import HelpLink from "@components/BuyForm/HelpLink";
import IconLinkButton from "@components/BuyForm/IconLinkButton";
import PageLayout from "@components/BuyForm/PageLayout";
import { useNavigation } from "@contexts/NavigationContainer";
import { buyFlowLayout, mediaQuery } from "@helpers";
import {
	ActivateFlowStep,
	ActivateFlowStepOrder,
	ActivateFlowOrderSteps,
} from "@helpers/ActivateFlowStep";
import React, { useEffect } from "react";
import styled from "styled-components";
import ActivateYourSim from "./Form/ActivateYourSim";
import MassRetailPlanCarousel from "./Form/MassRetailPlanCarousel";
import RegisterSim from "./Form/RegisterSim";

const HeaderWithLayout = withHeaderLayout(Header);

const Background = styled(BackgroundUnderlay)`
  grid-column: left / right;
  grid-row: header-start / bottom;

  ${mediaQuery.desktop} {
    grid-row: top / bottom;
  }
`;

const PageContent = styled.div`
  ${(props) =>
		props.isConfirmOrUpdatePlan &&
		`
 
   overflow-y: hidden;
  `}
  grid-column: col1-start / col1-end;
  grid-row: content-start / bottom;
  padding-bottom: 3rem;
  button {
    border: none !important;
    &:hover {
      border: none !important;
    }
  }

  ${mediaQuery.tabletAndDown} {
    margin: 0 auto;
    width: 100%;
    max-width: ${buyFlowLayout.DESKTOP_CONTENT_WIDTH}px;
  }

  ${mediaQuery.tabletAndUp} {
    ${(props) =>
			props.isConfirmOrUpdatePlan &&
			`
   margin: 0 auto;
   grid-column: 1 / -1 !important; 
   overflow-y: hidden;
  `}
    padding-bottom: 4rem;
  }

  ${mediaQuery.desktop} {
    grid-column: col1-start / col1-end;
    grid-row: content-start / footer-start;
  }
`;

const FooterNavigation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) =>
		props.backLinkVisible ? "space-between" : "flex-end"};
  margin-top: 0.75rem;
  button {
    border: none !important;
    &:hover {
      border: none !important;
    }
  }
`;

const FooterHelpLink = styled(HelpLink)`
  /* ${mediaQuery.desktop} {
    display: none;
  } */
`;

const ActivateForm = ({ massRetailcarouselData }) => {
	const { routeName, navigate } = useNavigation();

	const handleBack = () => {
		const currentIndex = ActivateFlowStepOrder[routeName];
		if (currentIndex < 1) return;
		const previousRouteName = ActivateFlowOrderSteps[currentIndex - 1];
		navigate(previousRouteName);
	};
	const isConfirmOrUpdatePlan =
		routeName === ActivateFlowStep.ConfirmOrUpdatePlan;

	const renderForm = () => {
		// console.log("activate journey ActivateSim.js", routeName);
		switch (routeName) {
			case ActivateFlowStep.ActivateSim:
				return <ActivateYourSim />;
			case ActivateFlowStep.RegisterSim:
				return <RegisterSim />;
			case ActivateFlowStep.ConfirmOrUpdatePlan:
				return (
					<MassRetailPlanCarousel
						massRetailcarouselData={massRetailcarouselData}
					/>
				);
			default:
				return <ActivateYourSim />;
		}
	};

	const backLinkVisible = routeName === ActivateFlowStep.RegisterSim;
	const footerLinksVisible =
		routeName === ActivateFlowStep.ActivateSim ||
		routeName === ActivateFlowStep.RegisterSim ||
		routeName === ActivateFlowStep.ConfirmOrUpdatePlan;

	// scroll to top of window on any route change
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [routeName]);

	return (
		<>
			<PageLayout>
				<HeaderWithLayout />
				<PageContent isConfirmOrUpdatePlan={isConfirmOrUpdatePlan}>
					{renderForm()}

					<FooterNavigation backLinkVisible={backLinkVisible}>
						{backLinkVisible ? (
							<IconLinkButton
								iconName="chevron-left"
								onClick={handleBack}
								marginLeft="10px"
								iconWidth="24px"
							>
								Back
							</IconLinkButton>
						) : null}
						<FooterHelpLink />
					</FooterNavigation>

					{footerLinksVisible ? <FooterLinks /> : null}
				</PageContent>

				<Background />

				<BuyStepJumper />
			</PageLayout>
		</>
	);
};

export default ActivateForm;
